import { JsonEditorSchema } from "@/shared/JsonEditorSchema/models/JsonEditorSchema";
import { JsonEditorType } from "@/shared/JsonEditorSchema/models/JsonEditorType";
import { RuleFieldType } from "@/components/DataCleaning/models/RuleFieldType";
import { IQueueExecutionDataCleaningProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import SchemaGenerator from "./SchemaGenerator";


export class DataCleaningSchemaGenerator extends SchemaGenerator<IQueueExecutionDataCleaningProp> {

    public createRootSchema(): JsonEditorSchema<IQueueExecutionDataCleaningProp> {

        const rootSchema: JsonEditorSchema<IQueueExecutionDataCleaningProp> = {
            type: 'object',
            additionalProperties: false,
            properties: {
                output: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        fileName: { type: 'string' },
                    },
                    required: ['fileName']
                },
                rules: {
                    type: 'array',
                    items: {
                        type: 'object',
                        additionalProperties: true,
                        properties: {
                            type: { type: 'string' }
                        },
                        required: ["type"]
                    }
                }
            },
            required: ['rules'],
        };

        return rootSchema;
    }

    public mapType(fieldType: any): JsonEditorType | null {
        switch (fieldType) {
            case RuleFieldType.Text:
            case RuleFieldType.Select:
            case RuleFieldType.SelectOrCreate:
            case RuleFieldType.ColumnSelectOrCreate:
            case RuleFieldType.ColumnSelect:
            case RuleFieldType.SelectJson:
            case RuleFieldType.ColorPicker:
            case RuleFieldType.StringTemplate:
            case RuleFieldType.RegularExpression:
                return 'string';
            case RuleFieldType.Number:
                return 'number';
            case RuleFieldType.Boolean:
                return 'boolean';
            case RuleFieldType.Array:
            case RuleFieldType.SourceDestinationPairArray:
            case RuleFieldType.MultiSelect:
            case RuleFieldType.ColumnMultiSelect:
            case RuleFieldType.ColumnMultiSelectOrCreate:
                return 'array';
            case RuleFieldType.Object:
            case RuleFieldType.Json:
                return 'object';
            default:
                return null;
        }
    }

    public populateVariants(schema: JsonEditorSchema<IQueueExecutionDataCleaningProp>, variants: Array<any>, options: any): void {

        schema.properties.rules!.items = {
            type: 'object',
            additionalProperties: options.additionalProperties,
            required: ['type'],
            allOf: variants.map((variant: any) => {
                const { type: _t, ...otherProps } = variant.properties;
                const typeValue = variant.properties.type?.enum?.[0];
                return {
                    if: {
                        properties: { type: { const: typeValue } },
                        required: ['type']
                    },
                    then: {
                        properties: otherProps,
                        ...(variant.required?.length > 1
                            ? { required: variant.required }
                            : {})
                    }
                };
            })
        };

    }
}

export default DataCleaningSchemaGenerator;
